import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/group-setup/wallets.md?raw';

const GroupSetupWallets: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default GroupSetupWallets;
